import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions } from 'vuex';
import { LoadData, DeleteData, GetOneById } from '@/api/Announcement';
export default {
  data: function data() {
    return {
      TableData: [],
      mainData: [],
      totolPage: 1,
      formHead: {
        TYPE_ID: '1',
        Page: 1,
        Limit: 10,
        ORGANIZE_ID: 10
      },
      columnConfig: {
        resizable: true
      },
      typeList: [{
        label: '公司公告',
        value: 1
      }, {
        label: '供应商须知',
        value: 2
      }],
      showList: [{
        label: '是',
        value: 1
      }, {
        label: '否',
        value: 0
      }],
      delList: [],
      dialogContent: {},
      dialogVisible: false
    };
  },
  created: function created() {
    this.getLoadData();
  },
  methods: _objectSpread(_objectSpread({}, mapActions('Portal/Announcement', ['setOrderStatu'])), {}, {
    // 查看公告
    checkNotice: function checkNotice(row) {
      console.log(row);
      this.dialogContent = row;
      this.dialogContent.simpleCONTENT = this.byteLength(this.dialogContent.simpleCONTENT);
      this.dialogVisible = true;
    },
    byteLength: function byteLength(val) {
      var len = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 25;
      var b = len; // 规定长度

      var init = 0;
      var newVal = ''; // 获取字符串字节总长度

      var totalLen = 0;

      for (var l = 0; l < val.length; l++) {
        if (val.charCodeAt(l) > 255) {
          totalLen += 2;
        } else {
          totalLen++;
        }
      }

      for (var i = 0; i < val.length; i++) {
        if (init <= b) {
          newVal += val[i];

          if (val.charCodeAt(i) > 255) {
            init += 2;
          } else {
            init++;
          }
        }
      }

      return newVal + (totalLen > b ? '...' : '');
    },
    // 编辑公告
    editNotice: function editNotice(e) {
      this.dialogVisible = false;
      this.$emit('editNotice');
      this.Bus.emit('mstData', e);
      this.Bus.emit('onClickEditOrder');
      this.setOrderStatu('editOrder');
    },
    // 行删除公告
    delNotice: function delNotice(row) {
      this.delList = [row];
      this.handelDelBtn();
    },
    handelAddBtn: function handelAddBtn() {
      this.$emit('AddNotice'); // this.Bus.emit('mstData', '')

      this.Bus.emit('onClickaddOrder');
      this.setOrderStatu('addOrder');
    },
    handelDelBtn: function handelDelBtn() {
      var _this = this;

      this.$confirm('确定要删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.delConfirm();
      }).catch(function () {
        _this.$message.warning('已取消');
      });
    },
    delConfirm: function delConfirm() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return DeleteData({
                  RemoveRecords: _this2.delList
                });

              case 2:
                res = _context.sent;

                _this2.$message.success('删除成功');

                console.log(res);

                _this2.getLoadData();

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleClick: function handleClick(tab, event) {
      console.log(tab.name);
      this.formHead.TYPE_ID = tab.name;
      this.getLoadData();
    },
    getLoadData: function getLoadData() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return LoadData(_this3.formHead);

              case 2:
                res = _context2.sent;

                if (res.data) {
                  _this3.TableData = res.data ? res.data : [];
                  _this3.totolPage = res.TotalCount ? res.TotalCount : 0;
                  _this3.mainData = res.data.Items;

                  if (_this3.TableData) {
                    _this3.mainData.forEach(function (v) {
                      var content = v.CONTENT;
                      v.simpleCONTENT = _this3.ToString(content);
                      v.ISSUE_DATE = v.ISSUE_DATE.substr(0, 10);
                    });

                    console.log('tttt', _this3.TableData);
                  }
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    handleSizeChange: function handleSizeChange(E) {
      console.log(E);
      this.formHead.Limit = E;
      this.getLoadData();
    },
    handleCurrentChange: function handleCurrentChange(E) {
      console.log(E);
      this.formHead.Page = E;
      this.getLoadData();
    },
    ToString: function ToString(value) {
      var tag = document.createElement('div');
      tag.innerHTML = value;
      var strCode = tag.innerText || tag.textContent;
      tag = null;
      return strCode;
    },
    selectAllEvent: function selectAllEvent(_ref) {
      var checked = _ref.checked;
      var records = this.$refs.xTable.getCheckboxRecords();
      this.delList = records;
      console.log(this.delList);
    },
    selectChangeEvent: function selectChangeEvent(_ref2) {
      var checked = _ref2.checked;
      var records = this.$refs.xTable.getCheckboxRecords();
      this.delList = records;
    },
    // 发布方式过滤
    formatterType: function formatterType(_ref3) {
      var cellValue = _ref3.cellValue;
      var item = this.typeList.find(function (item) {
        return item.value === cellValue;
      });
      return item ? item.label : '';
    },
    // 显示过滤
    formatterShow: function formatterShow(_ref4) {
      var cellValue = _ref4.cellValue;
      var item = this.showList.find(function (item) {
        return item.value === cellValue;
      });
      return item ? item.label : '';
    }
  })
};